import React from 'react'
import { grades } from '../assets/default-objects'

export default function GradeSelect({ url, formKey, className, handleSelect, formData }) {

  const options = grades

  return (
    <>
      {
        (options && formData) ?
          < select
            className={`form-control col pl-0 ${className}`
            }
            id={formKey}
            onChange={handleSelect}
            value={formData.gradeEntering == (null || undefined) ? ' ' : formData.gradeEntering}
          >
            {options.map((option) => {
              return (
                <option key={option.label} value={option.value}>
                  {option.label}
                </option>
              )
            })}
            < option value=" "> {'None'}</option>
          </select>
          :
          < select
            className={`form-control col pl-0 ${className}`}
            id={formKey}
          >
            < option value=" "> {'None'}</option>
          </select>
      }
    </>
  )
}
